import getApi from '../../api/apisauceConfig'

export const deletePatientTreatment = (patientId: number, treatmentId: string) =>
  getApi().delete<void>(`patients/${patientId}/treatments/${treatmentId}`)
